module.exports = __webpack_public_path__ + "img/logo.6d6199fe.png";